module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont-1dc35d.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.ttf?v=4.6.3
// module id = 808
// module chunks = 2